/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = OurAppointment
 *
 * 1 = InCdk
 *
 * 2 = ImportSoHeader
 *
 * 3 = HoursBooked
 */
export enum ServiceBookingAppointmentStatusEnum {
  OurAppointment = 0,
  InCdk = 1,
  ImportSoHeader = 2,
  HoursBooked = 3,
}
